module.exports = __webpack_public_path__ + "static/media/Combat.cffb1885.png";